const allTrue = (...args) => {
  for (let arg of args) {
    if (!arg) return false
  }
  return true
}

export default allTrue